import * as React from 'react';
import { Modal, Popup } from 'semantic-ui-react';

import { AlphasAddToList } from '../../components/AlphasAddToList';
import { addModifiers } from '../../shared/helpers';

interface AlphasAddToListContainerProps {
  alphasData: any[] | undefined;
  containerClasses?: string;
  btnClasses: string;
  btnTitle?: string;
  btnTitleClass?: string;
  btnLabel?: string;
  onAfterOpen?: any;
  disabled?: boolean;
  /**
   * Optional GA tracker invoked when the Add-to-list modal opens. Each caller is
   * responsible for firing its page-specific event (e.g. `sim_click_add_to_list`
   * from Simulate, `alphas_click_add_to_list` from Alphas).
   */
  onTrackOpen?: () => void;
}

interface AlphasAddToListContainerState {
  showModal: boolean;
}

class AlphasAddToListContainer extends React.Component<AlphasAddToListContainerProps, AlphasAddToListContainerState> {
  constructor(props: AlphasAddToListContainerProps) {
    super(props);
    this.state = { showModal: false };
  }

  handleOpenModal = () => {
    // Fire caller-supplied analytics hook BEFORE any other side effect so the
    // event is emitted even if subsequent logic short-circuits. Only fires on
    // open (not close) — see handleCloseModal.
    this.props.onTrackOpen?.();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { disabled = false } = this.props;

    // @types/react@19 collapses the withRouter+connect wrapper's own props to `never`,
    // so AlphasAddToList's own props are rejected. Cast to a permissive type; runtime is unchanged.
    const AlphasAddToListTyped = AlphasAddToList as React.ComponentType<any>;

    return (
      <div className={this.props.containerClasses}>
        <button
          onClick={this.handleOpenModal}
          className={addModifiers(this.props.btnClasses, [disabled ? 'disabled' : ''])}
          type="button"
          title={this.props.btnTitle}
          disabled={disabled}
        >
          {this.props.btnTitleClass && (
            <Popup
              disabled={disabled}
              on="hover"
              mouseEnterDelay={500}
              position="top center"
              content={this.props.btnLabel}
              trigger={<div className={this.props.btnTitleClass} />}
            />
          )}
          <span>{this.props.btnLabel}</span>
        </button>
        {this.props.alphasData && (
          <Modal onOpen={this.props.onAfterOpen} closeIcon={true} open={this.state.showModal} onClose={this.handleCloseModal}>
            <Modal.Content>
              <AlphasAddToListTyped alphas={this.props.alphasData} handleCloseModal={this.handleCloseModal} />
            </Modal.Content>
          </Modal>
        )}
      </div>
    );
  }
}

export default AlphasAddToListContainer;
